/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CreateElectronBeamQualityDto } from './CreateElectronBeamQualityDto';
import {
    instanceOfCreateElectronBeamQualityDto,
    CreateElectronBeamQualityDtoFromJSON,
    CreateElectronBeamQualityDtoFromJSONTyped,
    CreateElectronBeamQualityDtoToJSON,
} from './CreateElectronBeamQualityDto';
import type { CreatePhotonBeamQualityDto } from './CreatePhotonBeamQualityDto';
import {
    instanceOfCreatePhotonBeamQualityDto,
    CreatePhotonBeamQualityDtoFromJSON,
    CreatePhotonBeamQualityDtoFromJSONTyped,
    CreatePhotonBeamQualityDtoToJSON,
} from './CreatePhotonBeamQualityDto';

/**
 * @type CreateBeamQualityDto
 * 
 * @export
 */
export type CreateBeamQualityDto = { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.TreatmentMachines.Configuration.CreateElectronBeamQualityDto, Ptw.Ptw100.AppZero.Application.Shared' } & CreateElectronBeamQualityDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.TreatmentMachines.Configuration.CreatePhotonBeamQualityDto, Ptw.Ptw100.AppZero.Application.Shared' } & CreatePhotonBeamQualityDto;


export function CreateBeamQualityDtoFromJSON(json: any): CreateBeamQualityDto {
    return CreateBeamQualityDtoFromJSONTyped(json, false);
}

export function CreateBeamQualityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateBeamQualityDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.TreatmentMachines.Configuration.CreateElectronBeamQualityDto, Ptw.Ptw100.AppZero.Application.Shared':
            return {...CreateElectronBeamQualityDtoFromJSONTyped(json, true), $type: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.TreatmentMachines.Configuration.CreateElectronBeamQualityDto, Ptw.Ptw100.AppZero.Application.Shared'};
        case 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.TreatmentMachines.Configuration.CreatePhotonBeamQualityDto, Ptw.Ptw100.AppZero.Application.Shared':
            return {...CreatePhotonBeamQualityDtoFromJSONTyped(json, true), $type: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.TreatmentMachines.Configuration.CreatePhotonBeamQualityDto, Ptw.Ptw100.AppZero.Application.Shared'};
        default:
            throw new Error(`No variant of CreateBeamQualityDto exists with '$type=${json['$type']}'`);
    }
}

export function CreateBeamQualityDtoToJSON(value?: CreateBeamQualityDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.TreatmentMachines.Configuration.CreateElectronBeamQualityDto, Ptw.Ptw100.AppZero.Application.Shared':
            return CreateElectronBeamQualityDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.TreatmentMachines.Configuration.CreatePhotonBeamQualityDto, Ptw.Ptw100.AppZero.Application.Shared':
            return CreatePhotonBeamQualityDtoToJSON(value);
        default:
            throw new Error(`No variant of CreateBeamQualityDto exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the CreateBeamQualityDto interface.
 */
export function instanceOfCreateBeamQualityDto(value: any): value is CreateBeamQualityDto {
    if (instanceOfCreateElectronBeamQualityDto(value)) return true;
    if (instanceOfCreatePhotonBeamQualityDto(value)) return true;
    return false;
}

